import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { adicionarUsuariosModel } from '../models/pagamento.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiInfocapebsVindiService {

  private ENV: any = environment;
  private URL;
  assinaturaVindi: any;
  assinaturaApiceDb: any;
  promisseAssinaturaVindi = new Map();
  promiseEmAndamento = null;

  constructor(private http: HttpClient, private BS: BaseService) {
    this.URL = this.ENV.apice.url;
  }

  cadastroCorretroaVindi(body) {
    return this.http.post(this.URL + `cadastros/cadastroCorretroa`, body, this.BS.getHeaders(true)).toPromise();
  }

  buscaPlanos() {
    return this.http.get(this.URL + `cadastros/getPlanos`, this.BS.getHeaders(true)).toPromise();
  }

  buscaProdutos() {
    return this.http.get(this.URL + `cadastros/getProdutos`, this.BS.getHeaders(true)).toPromise();
  }

  criaPerfilPagto(body) {
    let publicApiKey = `${this.ENV.vindi.publicKey}:`; 
    let headers = {
      "headers": {
        "Authorization": "Basic " + btoa(publicApiKey)
      }

    }

    return this.http.post(this.ENV.vindi.url + `public/payment_profiles`, body, headers).toPromise().catch(error => { return error });
  }

  async getAssinatura(assinaturaId, futura = false) {
    if (this.promisseAssinaturaVindi.has(assinaturaId)) {
        await this.promisseAssinaturaVindi.get(assinaturaId);
    }

    if (futura || !this.assinaturaApiceDb || this.assinaturaApiceDb?.assinaturaVigente?.id !== assinaturaId || !this.assinaturaVindi) {
        let res;
        let attempts = 0;

        const promise = new Promise(async (resolve, reject) => {
            while (!res && attempts < 10) {
                try {
                    res = await this.http.get(this.URL + `cadastros/assinatura/${assinaturaId}`, this.BS.getHeaders(true)).toPromise();
                    attempts++;
                } catch (error) {
                    console.error('Erro ao buscar assinatura no vindi: ', error);
                    if (attempts >= 10) {
                        reject(error);
                    }
                }
            }

            if (res) {
                this.assinaturaVindi = res;
                resolve(res);
            }
        });

        this.promisseAssinaturaVindi.set(assinaturaId, promise);
        return promise;
    } else {
        return this.assinaturaVindi;
    }
}

  cancelaAssinatura(assinaturaId) {
      return this.http.delete(this.URL + `cadastros/assinatura/${assinaturaId}`, this.BS.getHeaders(true)).toPromise();
  }

  alterarMeioPagamentoAssinatura(body) {
    return this.http.post(this.URL + `cadastros/atualizaTipoPagAssinatura`, body, this.BS.getHeaders(true)).toPromise();
  }

  alteraFormaPagamentoFatura(body) {
    return this.http.post(this.URL + `cadastros/atualizaTipoPagFatura`, body, this.BS.getHeaders(true)).toPromise();
  }

  cancelaCartao(idCartao) {
    return this.http.post(this.URL + `cadastros/cancelaCartao/${idCartao}`, {}, this.BS.getHeaders(true)).toPromise();
  }

  confirmaFormaPagto(body) {
    return this.http.post(this.URL + `cadastros/confirmaFormaPagto`, body, this.BS.getHeaders(true)).toPromise();
  }

  salvarAssinatura(body) {
    return this.http.post(this.URL + `cadastros/assinatura`, body, this.BS.getHeaders(true)).toPromise();
  }

  adicionarUsuariosExtras(body: adicionarUsuariosModel) {
    return this.http.post(this.URL + `cadastros/usuariosAdicionais`, body, this.BS.getHeaders(true)).toPromise();
  }

 

async dadosAssinaturaDBApice(buscarNovamente = false) {
    if (!buscarNovamente && this.assinaturaApiceDb) {
        return this.assinaturaApiceDb;
    }

    if (this.promiseEmAndamento) {
        await this.promiseEmAndamento;
    }

    const observable = this.http.get(this.URL + `cadastros/assinatura-apice`, this.BS.getHeaders(true));
    this.promiseEmAndamento = firstValueFrom(observable);

    try {
        this.assinaturaApiceDb = await this.promiseEmAndamento;
        return this.assinaturaApiceDb;
    } catch (error) {
        console.error(error);
        throw error;
    } finally {
        this.promiseEmAndamento = null;
    }
}

  checkStatusPagamento(assinatura?: boolean, faturaCode?: string, checkExisteAssinatura = false, corretoraId = null) {
    let url = this.URL + 'cadastros/checkPagamento';

    if (assinatura) {
      url += '?assinatura=true';
    } else if (faturaCode) {
      url += '?faturaCode=' + faturaCode;
    }
    
    if (corretoraId) {
      url += '&corretoraId=' + corretoraId;
    }

    if (checkExisteAssinatura) {
      url += '&check=true';
    }

    return this.http.get(url, this.BS.getHeaders(true)).toPromise();
  }

  cobrancaManual(body: any) {
    return this.http.post(this.URL + `cadastros/cobrancaManual`, body, this.BS.getHeaders(true)).toPromise();
  }

  buscaFaturas() {
    return this.http.get(`${this.URL}cadastros/buscaFaturas`, this.BS.getHeaders(true)).toPromise();
  }

  buscaDesconto(cupom: string, plano: string): Promise<any> {
    // buscaDesconto(cupom: string) : Promise<any> {
    return this.http.get(`${this.URL}cadastros/buscaDesconto/${cupom}/${plano}`, this.BS.getHeaders(true)).toPromise();
    // return this.http.get(`${this.URL}cadastros/buscaDesconto/${cupom}`, this.BS.getHeaders(true)).toPromise();	
  }

  geraRenovacaoManual(id: number): Promise<any> {
    return this.http.post(`${this.URL}cadastros/renovacaoManual/${id.toString()}`, {}, this.BS.getHeaders(true)).toPromise();
  }

}